import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import blobs from './Blobs';
import fish from './Fish';
import longRectangle from './LongRectangle';
import shortRectangle from './ShortRectangle';

import colorStyles from './style/color.module.css';
import generalStyles from './style/general.module.css';
import rotationStyles from './style/rotation.module.css';
import sizeStyles from './style/size.module.css';

const patternColors = Object.keys(colorStyles);
const patternRotations = Object.keys(rotationStyles);
const patternSizes = Object.keys(sizeStyles);

const cx = classNames.bind({
  ...colorStyles,
  ...generalStyles,
  ...rotationStyles,
  ...sizeStyles,
});

export default function Pattern({
  color,
  type,
  rotation,
  size,
  top,
  left,
  right,
  bottom,
}) {
  const patternClassName = cx('pattern', color, rotation, size, type);
  let pattern = fish;

  const patternStyle = {
    top,
    left,
    right,
    bottom,
  };

  if (type === 'shortRectangle') {
    pattern = shortRectangle;
  } else if (type === 'longRectangle') {
    pattern = longRectangle;
  } else if (type === 'blobs') {
    pattern = blobs;
  }

  return (
    <div className={patternClassName} style={patternStyle}>
      {pattern}
    </div>
  );
}

Pattern.propTypes = {
  type: PropTypes.oneOf(['blobs', 'fish', 'longRectangle', 'shortRectangle']),
  color: PropTypes.oneOf(patternColors),
  rotation: PropTypes.oneOf(patternRotations),
  size: PropTypes.oneOf(patternSizes),
  top: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  left: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

Pattern.defaultProps = {
  color: 'marvel',
  type: 'fish',
  rotation: 'horizontal',
  size: 's',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
};



// WEBPACK FOOTER //
// ./src/components/commons/Pattern/index.js